__turbopack_context__.v({
  "backdrop": "LVcD7G_backdrop",
  "bodyWrapper": "LVcD7G_bodyWrapper",
  "content": "LVcD7G_content" + " " + __turbopack_context__.i(248112)["focusOutline"],
  "dialogTitle": "LVcD7G_dialogTitle",
  "footer": "LVcD7G_footer",
  "footerNotSticky": "LVcD7G_footerNotSticky",
  "footerSticky": "LVcD7G_footerSticky",
  "mobileBottom": "LVcD7G_mobileBottom",
  "noMobileBottomRadius": "LVcD7G_noMobileBottomRadius",
  "noPadding": "LVcD7G_noPadding",
  "sideBottom": "LVcD7G_sideBottom",
  "sideLeft": "LVcD7G_sideLeft",
  "sideRight": "LVcD7G_sideRight",
  "slideInFromBottom": "LVcD7G_slideInFromBottom",
  "slideInFromLeft": "LVcD7G_slideInFromLeft",
  "slideInFromRight": "LVcD7G_slideInFromRight",
  "slideOutToBottom": "LVcD7G_slideOutToBottom",
  "slideOutToLeft": "LVcD7G_slideOutToLeft",
  "slideOutToRight": "LVcD7G_slideOutToRight",
});
